import { getPayRentUrl } from '../../sections/locationPage/components/selectLocations/helper/cookieHelpers';
import { UserFlowTypes } from '../../sections/userFlows';

export const getLinkInfo = (
  locationDetails: any,
  LinkText: string,
  linkTo: string,
  globalContext?: any
) => {
  if (locationDetails && locationDetails?.length > 1) {
    const selectedLocation =
      locationDetails?.filter(
        (eachLocation: UserFlowTypes.TLocationDetail) =>
          eachLocation.facility_sms_id === globalContext?.loggedInSmsFacilityId
      )[0] || locationDetails[0];

    if (LinkText === 'Pay Rent') {
      const payRentUrl = getPayRentUrl(globalContext?.loggedInSmsFacilityId);
      return `/${selectedLocation.location_state}/${selectedLocation.location_city}/${payRentUrl}`;
    } else if (LinkText === 'Contact Us') {
      return '/select-location-page';
    } else {
      return linkTo;
    }
  } else if (
    locationDetails &&
    (LinkText === 'View Rates' ||
      LinkText === 'Pay Rent' ||
      LinkText === 'Contact Us')
  ) {
    const { location_state, location_city } = locationDetails[0];
    return `/${location_state}/${location_city}${linkTo}`;
  } else {
    return linkTo;
  }
};
